import { RefObject, useLayoutEffect, useState } from 'react';

const useResizeObserver = (refElement: RefObject<HTMLElement | null>) => {
  const [width, setWidth] = useState<number>();

  useLayoutEffect(() => {
    if (!refElement.current || !window.ResizeObserver) {
      // Ignore if `ResizeObserver` not available in the browser.
      return;
    }
    const resizeObserver = new ResizeObserver(entries => setWidth(entries[0]?.contentRect.width));
    resizeObserver.observe(refElement.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [refElement]);

  return { width };
};

export default useResizeObserver;
